export const BASE_URL = 'https://mobile-department.innowise.com';
export const PATH = {
  LOGO: 'rest/imagerest/v1/icon_logo',
  HEADER_IMAGE: 'rest/imagerest/v1/icon_headerimage',
  SECTION_IMAGE: 'rest/imagerest/v1/icon_sectionimage',
  SCREENSHOT: 'rest/restscreenshots/v1/screenshots',
  TOP_PROJECTS: '/rest/topprojectsrest/v1/topprojects',
  PLATFORMS: '/rest/platformsrest/v1/platform',
  DOMAINS: '/rest/domainrest/v1/domains',
  TECHNOLOGIES: '/rest/resttechnology/v1/technology',
  PROJECTS: '/rest/restproject/v1/projects',
};
export const OUR_PRODUCTS_PAGE = {
  ERROR_MESSAGE: 'Error...',
  HEADER_SECTION_TITLE: 'Our products',
  HEADER_SECTION_SUBTITLE: 'help our clients attain great goals',
  HEADER_SECTION_INFO: 'Information',
  INFORMATION:
    'Lorem ipsum dolor sit amet consectetur adipisicing elit. Magni voluptatibus deleniti itaque consectetur officia velit accusantium labore omnis tenetur vel ut, magnam quam. Expedita consequatur aspernatur odio consectetur? Voluptatum quaerat earum ea numquam suscipit nam debitis, maxime ex mollitia odio cupiditate, dolor deleniti beatae non vitae est asperiores possimus quis?',
};
export const FILTER_CATEGORIES = {
  FRAMEWORKS_FIRST_NAME: 'Native',
  FRAMEWORKS_FIRST_VALUE: '_Native',
  FRAMEWORKS_SECOND_NAME: 'Low-Code',
  FRAMEWORKS_SECOND_VALUE: 'Low_Code',
  FRAMEWORKS_THIRD_NAME: 'Cross-Platform',
  FRAMEWORKS_THIRD_VALUE: 'Cross',
  CATEGORY_PLATFORM: 'Platforms',
  CATEGORY_DOMAINS: 'Domains',
  CATEGORY_FRAMEWORKS: 'Frameworks',
  CATEGORY_TECHNOLOGIES: 'Technologies',
  NOT_FOUND_TEXT: 'No projects with these categories:(',
};
export const DATA_TYPE_ERROR_MESSAGE = 'No data available';
export const COPYRIGHT_NOTICE = `© 2007-${new Date().getFullYear()} Innowise. All Rights Reserved.`;
export const LEGAL_ADDRESS_TEXT =
  'Innowise Sp. z o.o Ul. Rondo Ignacego Daszyńskiego, 2B-22P, 00-843 Warsaw, Poland';
export const PRIVACY_POLICY_TITLE = 'Privacy Policy.';
export const COOKIES_TITLE = 'Cookies Policy.';
export const CONTACT_INFO = {
  FIRST_TITLE: 'USA',
  FIRST_NUMBER: '+1 (917) 267 7727, +1 (772) 232 7337',
  SECOND_TITLE: 'Germany',
  SECOND_NUMBER: '+49 (681) 988 999 59',
  THIRD_TITLE: 'Italy',
  THIRD_NUMBER: '+39 (377) 399 44 35',
  FOURTH_TITLE: 'Poland',
  FOURTH_NUMBER: '+48 (517) 370 938',
  FIFTH_TITLE: 'UAE',
  FIFTH_NUMBER: '+971 (58) 527 4499',
};
export const CONTACT_US_TITLE = 'Contact us';
export const ABOUT_US_INFO = {
  TITLE: 'About us',
  GITHYUB: 'GitHub',
  GOOGLE_PLAY: 'Google Play',
  APP_STORE: 'App Store',
};
export const ALL_TECHNOLOGIES_TITLE = 'Technologies we use in development';
export const ABOUT_US_TITLE = 'About Us';
export const SERVICES_INFO = {
  TITLE: 'Services',
  MOBILE: 'Mobile app development',
  BACK_END: 'Back-end development',
  DESIGN: 'UI/UX design',
  QA: 'Software testing and quality assurance',
};
export const CONTACT_US_FAQ =
  'Feel free to contact us and get all the answers you need.';
export const CTA_DESCRIPTION =
  'We are ready to go with you and develop your product with high quality in needed deadline';
export const TECHNOLOGIES_INFO = {
  TITLE: 'Technologies',
  IOS: 'iOS',
  ANDROID: 'Android',
  FLUTTER: 'Flutter',
  REACT_NATIVE: 'React Native',
  MENDIX: 'Mendix',
  FLUTTERFLOW: 'FlutterFlow',
  MAUI: 'MAUI',
};
